
	import {
		Component,
		Prop,
		Vue,
		Watch,
		Emit
	} from "vue-property-decorator";
	import {
		provinceAndCityData,
		regionData,
		provinceAndCityDataPlus,
		regionDataPlus,
		CodeToText,
		TextToCode
	} from 'element-china-area-data'
	import {
		ISingUpWriteParams,
		ISingUpFormParams
	} from "../Interfaces/write";
	import {
		PhoneRegExp,
		EmailRegExp,
		NumberRegExp
	} from "@/contants/regExp";
	import {
		current
	} from "@/contants/current";

	@Component
	export default class Write extends Vue {
		private current: any = {};
		private Count: number = 1;
		private formList: any[] = [];
		private cityformval : any = '';
		private flags = {
			showList: 0,
			isSubmit: true,
		};
		private UserEntity: any = [];
		private submitMsg = "您填写的信息有误 !";
		private is_vip: string = "0";
		private Rules = {};

		private options_ = regionData;

		private options = [];
		private list = [];
		private protocol: boolean = false;

		@Prop({
			type: Object,
			default: {},
		})
		formDatas!: ISingUpFormParams;
		// ----------

		/**
		 * @description: 将票种数据给父组件
		 */
		@Emit("handleGetFormData")
		handleGetFormDatas(type: string) {
			let userDatas: ISingUpWriteParams;

			userDatas = {
				type,
				is_vip: Number(this.is_vip),
				UserEntity: this.UserEntity,
			};

			return userDatas;
		}

		created() {
			if (!this.formDatas.is_vip) {
				this.is_vip = "3";
			}
			this.current = new current();
			let {
				count,
				Datas
			} = this.formDatas;
			let _count: number;
			if (Datas) {
				_count = count || Datas.length;
			} else {
				_count = count;
			}

			if (_count) {
				this.Count = _count;
				for (let i = 0; i < _count; i++) {
					this.setFormList();
				}
			} else {
				this.setFormList();
			}
		}

		/**
		 * @description: 根据人数生成对应数量的表单
		 */
		setFormList() {
			let _formList = this.current.cloneDeep(this.formDatas.form_Sets);
			let _item = {};

			for (let i = 0; i < _formList.length; i++) {
				let _items = _formList[i];
				_formList[i].SSL_errorMsg = "";
			}

			this.formList.push(_formList);

			this.subData(this.formList);

			if (this.formDatas.Datas) {
				this.UserEntity = this.formDatas.Datas;

				let _D = this.formDatas.Datas;

				let s = _D.length > this.formList.length ? this.formList.length : _D.length;

				for (let a = 0; a < s; a++) {
					for (let j in _D[a].DataEntity) {
						if( this.formList[a][j].formtype == 3 && this.formList[a][j].formfix == 0){
							var textValue =  _D[a].DataEntity[j].value
							this.formList[a][j].formval = textValue.split(',');
						}else{
							this.formList[a][j].formval = _D[a].DataEntity[j].value;
						}
					}
				}
			}
		}

		/**
		 * @description:二级数据中字符串类型的数组转为数组类型
		 */
		subData(forms: any) {
			for (let j = 0; j < forms.length; j++) {
				forms[j].map((k: any, i: number) => {
					let _formtype = k.formtype;
					if (_formtype === 2 || _formtype === 4 || _formtype === 8 || _formtype === 3) {
						let _formjsonval;
						if (typeof k.formjsonval == "string") {
							_formjsonval = JSON.parse(k.formjsonval);
						} else {
							_formjsonval = k.formjsonval;
						}
						if (_formtype === 3) {
							if (!this.formList[j][i].formval) {
								this.formList[j][i].formval = [];
							}
						}

						this.formList[j][i].formjsonval = _formjsonval;
						if (_formtype === 2) {
							this.formList[j][i].formval = this.formList[j][i].formjsonval[0].value;
						}
					} else if (_formtype === 1 && k.formfix === 1 && j) {
						this.formList[j][i].formval = "";
					}
				});
			}
		}
		/**
		 * @description:显示对应人员列表
		 */
		handlerClickSwitch(i: number) {
			this.flags.showList = i;
		}
		/**
		 * @description: 添加人员
		 */
		addPerson() {
			this.Count++;
			this.setFormList();
		}
		handleChangeAdd(item: any) {
			item.formvalcity = (this.$refs.cityRef as any)[0].getCheckedNodes()[0].pathLabels.join(" / ");
			// item.formval = item.formval.toString()
			item.formval = (this.$refs.cityRef as any)[0].getCheckedNodes()[0].pathLabels.join(",");
		}
		/**
		 * @description: 处理提交的数据
		 */
		handleSubmit(type: string) {
			let _flags = true;
			let _formList = this.current.cloneDeep(this.formList);
			let data = [],
				_datas = [];

			for (let i = 0; i < _formList.length; i++) {
				let _items = _formList[i];
				for (let j = 0; j < _items.length; j++) {
					let {
						formtype,
						formfix,
						formval,
						formtitle,
						isreq,
						formid,
						formvalcity,
					} = _items[j];

					if (type === "next") {
						console.log(this.protocol)
						if( !this.protocol) {
							this.$message({
								message: "请同意《用户协议》和《隐私政策》!",
								type: "warning"
							});
							return 
						}
						//多选的数组类型转为字符串
						if (formtype === 1 && formfix === 1) {
							if (this.handleRegBlur(_items[j], i, j) === false) {
								return;
							}
						} else if (formtype === 1 && formfix === 3) {
							//校验邮箱
							if (this.handleRegBlur(_items[j]) === false) {
								this.flags.showList = i;
								return;
							}
						} else if (formtype === 1 && formfix === 6) {
							//校验数字
							if (this.handleRegBlur(_items[j]) === false) {
								this.flags.showList = i;
								return;
							}
						} else if (formtype === 9) {
							//处理日期格式，并且不能选择小于当前日期的时间
							let _formDate = new Date(formval).getTime();
							let _d = _formDate - new Date(new Date().toLocaleDateString()).getTime();

							if (!_formDate) {
								if (isreq) {
									this.formList[i][j].SSL_errorMsg = "请选择日期";
									this.flags.showList = i;
								} else {
									formval = "";
								}
							} else {
								let _date = this.current.changeTimeStam(formval);
								formval = _date.year + "-" + _date.month + "-" + _date.day;
							}
							/**else {
							  if (_d < 0) {
							    this.formList[i][j].SSL_errorMsg = "不能小于当前日期";
							    this.noSubmit("您选择的日期，不能小于当前日期 ！");
							    this.flags.showList = i;
							  } else {
							    let _date = this.current.changeTimeStam(formval);
							    formval = _date.year + "-" + _date.month + "-" + _date.day;
							  }
							}*/
						}

						if (formval === "请选择" || !formval) {
							//将 "请选择"及空值都转为后台要求的空字符串类型，
							formval = "";
							// 判断是否为必填
							if (isreq) {
								this.formList[i][j].SSL_errorMsg = formtitle + "为必填项";
								this.noSubmit("必填项不能为空 ！");
								_flags = false;
								// 哪个人员缺少必填，显示对应人员的表单
								this.flags.showList = i;
								return;
							}
						}
						
					}
					data.push({
						value: formval,
						formvalcity: formvalcity,
						text: formtitle,
						formfix: formfix,
						formid: formid,
						formtype: formtype,
					});
				}
				for (let s in data) {
					//分割线不需要提交,去掉分割线
					data = data.filter((i: any) => {
						return i.formtype !== 7;
					});
				}
				_datas.push({
					DataEntity: data
				});
				data = [];
			}
			
			//console.log(_datas)
			if (_flags && this.flags.isSubmit) {
				this.UserEntity = _datas;
				console.log("提交的表单数据", this.UserEntity);
				this.handleGetFormDatas(type);
			}
		}

		/**
		 * @description: 校验
		 */
		handleRegBlur(item: any, i ? : any, j ? : any) {
			let {
				formtitle,
				isreq,
				formval
			} = item;
			if (isreq && !formval) {
				item.SSL_errorMsg = formtitle + "不能为空";
			} else {
				item.SSL_errorMsg = "";
			}
			if (formval) {
				if (item.formtype === 1 && item.formfix === 1) {
					// 校验手机号
					if (!PhoneRegExp.test(String(formval))) {
						item.SSL_errorMsg = "请输入正确的手机号";
						return false;
					}
					//校验重复手机号
					let _tel: any[] = [];
					for (let s in this.formList) {
						_tel.push(String(this.formList[s][j].formval));
						_tel.splice(i);
					}
					let _s = _tel.indexOf(String(formval));
					if (_s !== -1) {
						this.formList[i][j].SSL_errorMsg = "手机号不能重复";
						this.flags.showList = i;
						return false;
					}
				}
				if (item.formtype === 1 && item.formfix === 3 && !EmailRegExp.test(String(formval))) {
					item.SSL_errorMsg = "请输入正确的邮箱";
					return false;
				}
				if (item.formtype === 1 && item.formfix === 6 && !NumberRegExp.test(String(formval))) {
					item.SSL_errorMsg = "请输入有效的数字";
					return false;
				}
			}
		}
		/**
		 * 不能提交
		 */
		noSubmit(msg: string) {
			this.flags.isSubmit = false;
			setTimeout(() => {
				this.flags.isSubmit = true;
			}, 3000);
			this.submitMsg = msg;
		}
		goProtocol() {
			window.open('https://mp.weiqihd.com/msite/site/10697/11140')
		}
	}
